import { observable } from "mobx";

export default class Redirect {
  @observable
  redirectUrl: string;
}
